import Link from "next/link";
import { toUpper, get } from "lodash";

import styles from "components/product/card/ListCard.module.scss";

import WishlistButton from 'components/product/detail/wishlist/WishlistButton';
import Kind from 'components/product/detail/kind/Kind';
import {useTranslation} from "next-i18next";

const ListCard = ({
  id,
  name,
  shortDescription,
  urlTitle,
  kind
}) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.productCard} ${styles['item-'+toUpper(get(kind, 'hash', 'default'))]}`}>
        <div className={styles.content}>
            <div className={styles.headline}>
                <span className={styles.kind}>
                    <Kind kind={kind} />
                </span>
                <h2 className={styles.name}>{name}</h2>
            </div>
            <div
                className={styles.shortDescription}
                dangerouslySetInnerHTML={{
                    __html: shortDescription
                }}
            />
            <Link href="/produkt/[id]" as={`/produkt/${urlTitle}`}>
                <a className={styles.readMore}>
                  {t("Čítať viac")}
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 6L16 11L11 16" stroke="black" strokeLinecap="round" strokeLinejoin="round"/><path d="M15 11L5 11" stroke="black" strokeLinecap="round"/></svg>
                </a>
            </Link>
        </div>
        <div className={styles.wishlistWrapper}>
            <WishlistButton productId={id} kind={kind} />
        </div>
    </div>
  );
};

export default ListCard;
